import { Tooltip } from '@mui/material';

function NRTooltip({ tooltipValue, content, placement = 'top', tooltipWidth }) {
  const tooltipProps = {};

  if (tooltipWidth) {
    tooltipProps.slotProps = {
      tooltip: {
        sx: {
          maxWidth: `${tooltipWidth}px`,
          width: 'max-content',
          minWidth: 0,
          whiteSpace: 'normal',
          wordWrap: 'break-word',
          overflowWrap: 'break-word',
          '& .MuiTooltip-arrow': {
            color: 'inherit'
          }
        }
      }
    };
  }

  return (
    <>
      {!!tooltipValue && (
        <Tooltip title={tooltipValue} placement={placement} {...tooltipProps}>
          <span style={{ maxWidth: '100%', width: '100%' }}>{content}</span>
        </Tooltip>
      )}
      {!tooltipValue && <>{content}</>}
    </>
  );
}
export default NRTooltip;
